import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import type { PortalSession } from '@/types/api'
import {
  clearPortalSession,
  readPortalSession,
  writePortalSession,
} from '@/utils/storage'

export const useAuthStore = defineStore('memberPortalAuth', () => {
  const session = ref<PortalSession | null>(readPortalSession())
  const authenticated = computed(() => Boolean(session.value?.accessToken))

  const setSession = (value: PortalSession) => {
    session.value = value
    writePortalSession(value)
  }

  const clearSession = () => {
    session.value = null
    clearPortalSession()
  }

  return { authenticated, clearSession, session, setSession }
})
